import { render } from "./App.vue?vue&type=template&id=5c92e98e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5c92e98e&lang=css"

import exportComponent from "/Users/ryancompany/works/bao/xinyuanyiyuan/pet-mobile-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__